<template>
  <span class="ticket-status" :class="`ticket-status--${normalized}`" :title="label">
    {{ label }}
  </span>
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const props = defineProps({
  status: { type: String, default: '' }
})

const { t } = useI18n()

const I18N_MAP = {
  Open:   'tickets.Open',
  OnHold: 'tickets.OnHold',
  Closed: 'tickets.Closed',
  // Accessi DC: stati numerici (1 = presa in carico, 0 = completato), già gestiti dalle classi sotto
  1:      'tickets.1',
  0:      'tickets.0',
}

const normalized = computed(() =>
  typeof props.status === 'string' ? props.status.replace(/\s+/g, '') : ''
)

const label = computed(() => {
  const key = I18N_MAP[normalized.value]
  return key ? t(key) : normalized.value
})
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";

.ticket-status {
  display: inline-block;
  padding: 5px 12px;
  border-radius: 5px;
  font-size: $font14;
  font-family: OpenSansSemiBold, sans-serif;
  line-height: 1.4;
  white-space: nowrap;
  text-transform: uppercase;
  color: $white;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
}

.ticket-status--Open,
.ticket-status--1   { background-color: $blu; }

// testo scuro: sfondo giallo pastello richiede contrasto scuro
.ticket-status--OnHold { background-color: $statusOnHold; color: $bluFour; }

.ticket-status--Closed,
.ticket-status--0   { background-color: $statusClosed; }
</style>